import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";

import clear from "../../assets/Images/clear.png";
import iteration from "../../assets/Images/iteration.png";

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";






import "./LO.css"; // Import the CSS file

const LO3 = () => {
    const navigate = useNavigate();

    const cardslo3 = [
        {
            title: "Clear Starting Points",
            description: "",
            image: clear,
            path: '/lo3/clearstartingpoints'
        },

        {
            title: "Iteration",
            description: "",
            image: iteration,
            path: '/lo3/reasonforiteration'
        },

        // {
        //     title: "Before and after",
        //     description: "",
        //     image: "",
        //     path: '/beforeandafter'
        // },

        // {
        //     title: "Validation of iterations",
        //     description: "",
        //     image: "",
        //     path: '/validation'
        // },

        // {
        //     title: "Iterations on multiple areas",
        //     description: "",
        //     image: "",
        //     path: '/iterationonmultipleareas'
        // },
        



        
        
    ];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo3-headings">
                <h1>Creative Iterations</h1>
                {/* <p></p> */}

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>
            
            <div className="content-lo3">
                <div className="content-lo3-card-container">
                    {cardslo3.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-lo3" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-lo3-image" />
                            <h3 className="card-lo3-title">{title}</h3>
                            <p className="card-lo3-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default LO3;